import { routerReducer } from "@ngrx/router-store";
import { createReducer, on } from "@ngrx/store";
import * as RouterActions from "../actions";
import { initialRouteState, RouterStateUrl } from "../router.state";

export const reducers = {
    routerReducer,
};

export const routerExtras = createReducer(
    initialRouteState.state,
    on(
        RouterActions.updateActiveRoute,
        (state, { url, queryParams, params, children, title }): RouterStateUrl => ({
            ...state,
            url,
            queryParams,
            params,
            children,
            title,
        })
    ),
    on(
        RouterActions.updateBackButton,
        (state, { text, action, queryParams }): RouterStateUrl => ({
            ...state,
            backText: text,
            backAction: action,
            queryParams,
        })
    )
);
